import { Theme } from '@emotion/react';
import { switcherGroupDivider } from 'omakase/PadButton/padButtonCssDefs';

interface SwitcherGroupDividerProps {
  /**
   * The conditions that require hiding the divider
   */
  hide?: boolean;
}

const SwitcherGroupDivider: React.FunctionComponent<SwitcherGroupDividerProps> = ({ hide }) => {
  return <div css={(theme: Theme) => switcherGroupDivider(theme, { hide: !!hide })} />;
};

export default SwitcherGroupDivider;
